import { jsonFetch } from '~/common/http/fetch';
import type { EvaluatorModel } from '~/evaluator/domain/evaluator';
import type { InviteToken } from '~/evaluator/domain/invite-token';

export async function validateToken(
  token: string,
  dialect?: string,
): Promise<InviteToken> {
  const query = dialect ? `?dialect=${dialect}` : '';
  return jsonFetch<InviteTokenResponse>(`/api/v1/invite/${token}${query}`);
}

export type InviteTokenResponse =
  | {
      model: ExtractStrict<EvaluatorModel, 'DISCOVERY' | 'DDDRS' | 'EXPLORE'>;
      evaluatorId: string;
      referralCodeRequired: boolean;
    }
  | {
      model: ExtractStrict<EvaluatorModel, 'DFC'>;
      evaluatorId: string;
      learner: {
        fullName: string;
      };
      referralCodeRequired: boolean;
    };

type ExtractStrict<T, U extends T> = Extract<T, U>;
